<div class="copy-right text-center align-content-center py-1">
  {{ "Copyright © 2025 EVNHANOI" }}
</div>
